import { render } from "./ContentPlaytime.vue?vue&type=template&id=0ba72de4"
import script from "./ContentPlaytime.vue?vue&type=script&lang=js"
export * from "./ContentPlaytime.vue?vue&type=script&lang=js"
script.render = render

export default script